var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaseLayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "group-layers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group-layers"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 4.89,
    height: 4.89,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.11,
    y: 2,
    width: 4.89,
    height: 4.89,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 41.11,
    width: 4.89,
    height: 4.89,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.11,
    y: 41.11,
    width: 4.89,
    height: 4.89,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "18.42 27.75 10.61 31.5 24 37.93 37.39 31.5 29.58 27.75",
    fill: "#fc3768"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "18.42 20.25 10.61 24 24 30.43 37.39 24 29.58 20.25",
    fill: "#6d7c8c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24 22.93 37.39 16.5 24 10.07 10.61 16.5 24 22.93",
    fill: "#b1bfc9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.89,7.89H2a1,1,0,0,1-1-1V2A1,1,0,0,1,2,1H6.89a1,1,0,0,1,1,1V6.89A1,1,0,0,1,6.89,7.89ZM3,5.89H5.89V3H3Z",
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,7.89H41.11a1,1,0,0,1-1-1V2a1,1,0,0,1,1-1H46a1,1,0,0,1,1,1V6.89A1,1,0,0,1,46,7.89Zm-3.89-2H45V3H42.11Z",
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89,47H2a1,1,0,0,1-1-1V41.11a1,1,0,0,1,1-1H6.89a1,1,0,0,1,1,1V46A1,1,0,0,1,6.89,47ZM3,45H5.89V42.11H3Z",
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,47H41.11a1,1,0,0,1-1-1V41.11a1,1,0,0,1,1-1H46a1,1,0,0,1,1,1V46A1,1,0,0,1,46,47Zm-3.89-2H45V42.11H42.11Z",
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.81,
    y: 3.44,
    width: 2.84,
    height: 2,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.92,
    y: 3.44,
    width: 2.84,
    height: 2,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.03,
    y: 3.44,
    width: 2.84,
    height: 2,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.14,
    y: 3.44,
    width: 2.84,
    height: 2,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.25,
    y: 3.44,
    width: 2.84,
    height: 2,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.36,
    y: 3.44,
    width: 2.84,
    height: 2,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.81,
    y: 42.56,
    width: 2.84,
    height: 2,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.92,
    y: 42.56,
    width: 2.84,
    height: 2,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.03,
    y: 42.56,
    width: 2.84,
    height: 2,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.14,
    y: 42.56,
    width: 2.84,
    height: 2,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.25,
    y: 42.56,
    width: 2.84,
    height: 2,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.36,
    y: 42.56,
    width: 2.84,
    height: 2,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.56,
    y: 9.81,
    width: 2,
    height: 2.84,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.56,
    y: 14.92,
    width: 2,
    height: 2.84,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.56,
    y: 20.03,
    width: 2,
    height: 2.84,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.56,
    y: 25.14,
    width: 2,
    height: 2.84,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.56,
    y: 30.25,
    width: 2,
    height: 2.84,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.56,
    y: 35.36,
    width: 2,
    height: 2.84,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.45,
    y: 9.81,
    width: 2,
    height: 2.84,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.45,
    y: 14.92,
    width: 2,
    height: 2.84,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.45,
    y: 20.03,
    width: 2,
    height: 2.84,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.45,
    y: 25.14,
    width: 2,
    height: 2.84,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.45,
    y: 30.25,
    width: 2,
    height: 2.84,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.45,
    y: 35.36,
    width: 2,
    height: 2.84,
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,38.93a1,1,0,0,1-.43-.1L10.18,32.4a1,1,0,0,1-.57-.9,1,1,0,0,1,.57-.9L18,26.85a1,1,0,0,1,.86,1.8L12.92,31.5,24,36.82,35.08,31.5l-5.93-2.85a1,1,0,1,1,.86-1.8l7.81,3.75a1,1,0,0,1,.57.9,1,1,0,0,1-.57.9L24.43,38.83A1,1,0,0,1,24,38.93Z",
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,31.43a.91.91,0,0,1-.43-.1L10.18,24.9a1,1,0,0,1,0-1.8L18,19.35a1,1,0,0,1,.86,1.8L12.92,24,24,29.32,35.08,24l-5.93-2.85a1,1,0,0,1,.86-1.8l7.81,3.75a1,1,0,0,1,.57.9,1,1,0,0,1-.57.9L24.43,31.33A.91.91,0,0,1,24,31.43Z",
    fill: "#252b33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,23.93a.91.91,0,0,1-.43-.1L10.18,17.4a1,1,0,0,1-.57-.9,1,1,0,0,1,.57-.9L23.57,9.17a1,1,0,0,1,.86,0L37.82,15.6a1,1,0,0,1,.57.9,1,1,0,0,1-.57.9L24.43,23.83A.91.91,0,0,1,24,23.93ZM12.92,16.5,24,21.82,35.08,16.5,24,11.18Z",
    fill: "#252b33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseLayer);
export default __webpack_public_path__ + "static/media/baseLayer.36999b7b493c0d156cadee42331749e6.svg";
export { ForwardRef as ReactComponent };